import React from 'react';

import './arrow.scss';

const Arrow = ({ style, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 14"
      style={style}
      className={`svgArrow${className ? ` ${className}` : ''}`}
      height="14px"
      width="8px"
    >
      <path
        d="M.55 6.38L6.38.56a.48.48 0 01.7 0l.36.35a.51.51 0 010 .71L2.32 6.74l5.12 5.11a.51.51 0 010 .71l-.36.35a.48.48 0 01-.7 0L.55 7.09a.51.51 0 010-.71z"
        fill="#FFF"
        fillRule="evenodd"
      />
    </svg>
  );
};

export { Arrow };
